import axios, { AxiosRequestHeaders } from "axios";
//@ts-ignore
import { getToken, saveToken } from "../lib/utils";

const apiUrl =
	process.env.REACT_APP_CUPPYBET_API_BASE_URL || "http://localhost:3300";
// "http://localhost:3300";
// "https://cuppybetapi-85zft.ondigitalocean.app";

console.log(apiUrl, "apiUrl");
const api = axios.create({
	baseURL: apiUrl,
	headers: {
		accept: "*/*",
		"Content-Type": "application/json",
	},
});

api.interceptors.request.use(
	async (config) => {
		const result = getToken("accessToken");
		config.headers = { ...config.headers } as AxiosRequestHeaders;
		// console.log("Token Log:", result)
		if (result) {
			config.headers["Authorization"] = `Bearer ${result}`;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

const getNewAccessToken = async () => {
	const refreshToken = getToken("refreshToken");
	try {
		const response = await axios(`${apiUrl}/auth/refresh`, {
			method: "post",
			headers: {
				Authorization: `Bearer ${refreshToken}`,
			},
		});
		saveToken("accessToken", response.data?.accessToken);
		saveToken("refreshToken", response.data?.refreshToken);
		const newAccessToken = response.data.accessToken;
		return newAccessToken;
	} catch (error) {
		console.error("Failed to refresh access token:", error);
		localStorage.removeItem("accessToken");
		localStorage.removeItem("refreshToken");
		throw error;
	}
};

api.interceptors.response.use(
	(response) => response,
	async (error) => {
		const originalRequest = error.config;
		if (
			error.response &&
			error.response.status === 401 &&
			!originalRequest._retry
		) {
			originalRequest._retry = true;
			try {
				console.log("refreshing");
				const newAccessToken = await getNewAccessToken();
				axios.defaults.headers.common["Authorization"] =
					"Bearer " + newAccessToken;
				originalRequest.headers["Authorization"] = "Bearer " + newAccessToken;
				return api(originalRequest);
			} catch (refreshError) {
				console.error("Token refresh error:", refreshError);
				return Promise.reject(refreshError);
			}
		}
		return Promise.reject(error);
	}
);

export default api;
